module.exports = __webpack_public_path__ + "static/media/infoDialogB_background.93e4b501.png";


//////////////////
// WEBPACK FOOTER
// ./src/infoDialogB/static/infoDialogB_background.png
// module id = 375
// module chunks = 0